export { default } from "./ManuallyAddPlayerOptionView";
export type { ManuallyAddPlayerVariant } from "./ManuallyAddPlayerOptionView";
